import { App, defineAsyncComponent } from 'vue'

const RelatedMaterials = defineAsyncComponent(() => import('./RelatedMaterials.vue'))
const MainRelatedMaterials = defineAsyncComponent(() => import('./MainRelatedMaterials.vue'))
import Spotlight from './Spotlight.vue'
import Advantages from './Advantages.vue'

const install = (app: App<Element>, prefix = 'Slider'): void => {
  app
    .component(`${prefix}RelatedMaterials`, RelatedMaterials)
    .component(`${prefix}MainRelatedMaterials`, MainRelatedMaterials)
    .component(`${prefix}Spotlight`, Spotlight)
    .component(`${prefix}Advantages`, Advantages)
}

export default {
  install,
}
